var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterSoS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 5.5,
    fill: "#5C61F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 5.5,
    stroke: "#5C61F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.058 17.723C29.006 17.189 29.481 16.922 29.74 16.491C30 16.061 30 15.542 30 14.504V13.814C30 12.488 30 11.824 29.56 11.412C29.122 11 28.415 11 27 11H13C11.586 11 10.879 11 10.44 11.412C10.001 11.824 10 12.488 10 13.815V14.505C10 15.542 10 16.061 10.26 16.491C10.52 16.921 10.993 17.189 11.942 17.723L14.855 19.363C15.491 19.721 15.81 19.9 16.038 20.098C16.512 20.509 16.804 20.993 16.936 21.588C17 21.872 17 22.206 17 22.873V25.543C17 26.452 17 26.907 17.252 27.261C17.504 27.616 17.952 27.791 18.846 28.141C20.725 28.875 21.664 29.242 22.332 28.824C23 28.406 23 27.452 23 25.542V22.872C23 22.206 23 21.872 23.064 21.587C23.1896 21.0042 23.5059 20.4798 23.963 20.097",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSoS);
export default __webpack_public_path__ + "static/media/Filter_SoS.d519abbdbee494c4e8a4b19b452dccdd.svg";
export { ForwardRef as ReactComponent };